<template>
  <div>
    <b-table
      ref="leave-statistics-dt"
      id="leave-statistics-dt"
      responsive="sm"
      :fields="fields"
      :items="getCompanyLeaveStatistics"
      table-class="table-head-custom table-vertical-center mt-5"
    >
      <!-- A custom formatted header cell for field 'name' -->
      <template v-slot:head(index)="data">
        <span class="text-dark-75">{{ data.label.toUpperCase() }}</span>
      </template>

      <!-- A virtual column -->
      <template v-slot:cell(index)="data">
        <span class="font-weight-bolder">{{ data.index + 1 }}</span>
      </template>

      <template v-slot:cell(name)="data">
        <div class="d-flex flex-column">
          <span class="font-weight-bolder text-h6">
            {{ data.item.name }}
          </span>
        </div>
      </template>

      <template v-slot:cell(actions)="data">
        <div class="d-flex flex-row justify-content-left">
          <!-- begin::: edit-details button -->
          <b-button
            class="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
            :to="{
              name: 'LeavePageStatisticsList',
              query: { id: data.item.id },
            }"
          >
            <span class="svg-icon svg-icon-primary menu-icon">
              <inline-svg src="/media/svg/icons/Navigation/Right-2.svg" />
            </span>
          </b-button>
          <!-- end::: edit-details button -->
        </div>
      </template>

      <template #table-busy>
        <AppLoader #table-busy></AppLoader>
      </template>
    </b-table>

    <div class="d-flex justify-content-end" v-if="items">
      <b-pagination
        pills
        v-model="items.current_page"
        :total-rows="items.total"
        :per-page="items.per_page"
        aria-controls="leave-statistics-dt"
        @change="handlePageChange"
      ></b-pagination>
    </div>
    <LeavePageDetailsModal></LeavePageDetailsModal>
  </div>
</template>

<script>
import { alert } from "sweetalert2";
import { mapState, mapGetters } from "vuex";
import AppLoader from "@/modules/core/components/loaders/AppLoader";
import swal from "sweetalert";
import LeavePageDetailsModal from "@/modules/company/components/leave/type/LeavePageDetailsModal";
export default {
  name: "LeavePageDetailsTable",
  props: ["reload"],
  components: {
    LeavePageDetailsModal,
    AppLoader,
  },
  mounted() {},
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      fields: [
        // Mapped column which contains the name of the department
        { key: "week", label: this.$t("STATISTICS.WEEK") },
        { key: "pending", label: this.$t("STATISTICS.PENDING") },
        { key: "approved", label: this.$t("STATISTICS.APPROVED") },
        { key: "total", label: this.$t("STATISTICS.TOTAL") },
        { key: "actions", label: this.$t("DETAILSTABLE.ACT") },
      ],
    };
  },
  methods: {
    handlePageChange(value) {
      console.log(value);
      this.$store
        .dispatch("getDepartment", {
          page_number: value,
        })
        .catch(() => {
          alert({
            title: "Failed",
          });
        });
    },
    showLeaveDetails(row) {
      console.log("Selected Leave ", row);
      this.$bvModal.show("statistics-list-dt");
      this.$store.dispatch("assignEmployeeId", row.item.id).then(() => {
        console.log("Done setting employee Id");
      });
    },
    deleteEmployeeDetails() {
      swal({
        title: this.$t("ALERT.SURE"),
        text: this.$t("ALERT.WARNING"),
        icon: "warning",
        showCancelButton: true,
        dangerMode: true,
        buttons: [this.$t("BUTTON.CANCEL"), this.$t("BUTTON.OKAY")],
        closeOnConfirm: false,
        closeOnCancel: false,
      }).then((willDelete) => {
        if (willDelete) {
          swal(this.$t("ALERT.CONFIRM"), {
            icon: "success",
          });
        }
      });
    },
  },
  computed: {
    ...mapState({
      items: (state) => state.CompanyModule.department.list.items,
    }),
    ...mapGetters(["getCompanyLeaveStatistics", "getSuperAdminPermission"]),
  },
  watch: {
    reload() {
      console.log("Reload Table!");
      this.$refs["department-list-page-dt"].refresh();
    },
  },
};
</script>

<style scoped></style>
